import { BROKER_ACTIVACION, AGENCIA_ADLAB_PERU } from "../constants/permisos";

/**
 * ¿La venta (oportunidad) cae en el período broker de AdLab Perú?
 *
 * Réplica EXACTA de la condición `noEsPeriodoBroker` del paso 2 de
 * `resolverNombreEjecutivo.js` (mismos campos, mismo manejo de null), acotada al
 * broker AdLab (AGENCIA_ADLAB_PERU). Devuelve `true` solo cuando el cliente está
 * brokereado por AdLab (broker_id === 115) Y la venta pertenece al período broker.
 *
 * Una venta de cuenta cedida NO es del período broker solo si:
 *  - está excluida por-venta (excluir_broker === true), o
 *  - está muerta antes del período (0% creada pre-activación), o
 *  - está cerrada antes del período (100%): se usa fecha_cierre; si es NULL
 *    (históricas pre-trigger) se cae a created_at.
 * Todo lo demás (viva, o cerrada desde la activación) → período broker.
 *
 * Comparación por ID numérico (regla 8): nunca por nombre.
 *
 * @param {Object|null} opp - oportunidad (usa created_at, estatus, fecha_cierre, excluir_broker)
 * @param {Object|null} cliente - cliente de la venta (usa broker_id)
 * @returns {boolean}
 */
export function esVentaEnPeriodoBroker(opp, cliente) {
  if (!opp || !cliente || String(cliente.broker_id) !== String(AGENCIA_ADLAB_PERU)) return false;

  const createdAt = opp.created_at;
  const estatus = opp.estatus;
  const fechaCierre = opp.fecha_cierre;
  const excluirBroker = opp.excluir_broker;

  // Copiado al pie de la letra de resolverNombreEjecutivo.js (líneas 59-66).
  const brokerActivacion = new Date(BROKER_ACTIVACION);
  const noEsPeriodoBroker =
    // Exclusión POR-VENTA (reasignación Perú): fuerza titular real, nunca ADLAB (invariante: default false).
    excluirBroker === true ||
    (estatus === "0%" && createdAt && new Date(createdAt) < brokerActivacion) ||
    (estatus === "100%" &&
      ((fechaCierre && new Date(fechaCierre) < brokerActivacion) ||
        (!fechaCierre && createdAt && new Date(createdAt) < brokerActivacion)));

  return !noEsPeriodoBroker;
}
